import React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import GridPaper from "../ContentBox/GridPaper";
import {TableContainer} from "@mui/material";

type Props = {
  psychometricParameterName: string
  children: React.ReactNode
  edit: boolean
}

export default function PsychometricParameterTable({
                                                     psychometricParameterName,
                                                     children,
                                                     edit
                                                   }: Props) {

  return (
      <GridPaper title={`Psychometrische Kennwerte ${psychometricParameterName}`} xs={7} md={9}
                 xl={10}>
        <TableContainer>
          <Table sx={{minWidth: 650, overflowX: "scroll"}} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Psychometrischer Kennwert</TableCell>
                <TableCell>Vorgehen</TableCell>
                <TableCell>Ergebnisse</TableCell>
                <TableCell>Stichprobe</TableCell>
                {edit &&
                    <TableCell/>}
              </TableRow>
            </TableHead>
            <TableBody>
              {children}
            </TableBody>
          </Table>
        </TableContainer>
      </GridPaper>
  );
}